import { render, staticRenderFns } from "./SectionAgencyLegalInformationAddress.vue?vue&type=template&id=58a9efc6&"
import script from "./SectionAgencyLegalInformationAddress.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports